import { render, staticRenderFns } from "./_Chickin.vue?vue&type=template&id=bc78d6e2&"
import script from "./_Chickin.vue?vue&type=script&lang=js&"
export * from "./_Chickin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports